/**
 * 客户端席位授权相关 Hooks
 */

import {
  useMutation,
  useQuery,
  useQueryClient,
  type UseMutationResult,
  type UseQueryResult,
} from '@tanstack/react-query'
import {
  assignClientSeat,
  getClientSeatSummary,
  listClientSeatUsers,
  unassignClientSeat,
} from '@/services/clientSeatService'
import type { ClientSeatSummary, ClientSeatUsersData } from '@/types/clientSeat'

export const CLIENT_SEAT_SUMMARY_QUERY_KEY = ['client-seats', 'summary'] as const
export const CLIENT_SEAT_USERS_QUERY_KEY = ['client-seats', 'users'] as const

export function useClientSeatSummary(): UseQueryResult<ClientSeatSummary> {
  return useQuery({
    queryKey: CLIENT_SEAT_SUMMARY_QUERY_KEY,
    queryFn: getClientSeatSummary,
  })
}

export function useClientSeatUsers(): UseQueryResult<ClientSeatUsersData> {
  return useQuery({
    queryKey: CLIENT_SEAT_USERS_QUERY_KEY,
    queryFn: listClientSeatUsers,
  })
}

export function useAssignClientSeat(): UseMutationResult<void, Error, string> {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: assignClientSeat,
    onSuccess: (): void => {
      void queryClient.invalidateQueries({ queryKey: CLIENT_SEAT_SUMMARY_QUERY_KEY })
      void queryClient.invalidateQueries({ queryKey: CLIENT_SEAT_USERS_QUERY_KEY })
    },
  })
}

export function useUnassignClientSeat(): UseMutationResult<void, Error, string> {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: unassignClientSeat,
    onSuccess: (): void => {
      void queryClient.invalidateQueries({ queryKey: CLIENT_SEAT_SUMMARY_QUERY_KEY })
      void queryClient.invalidateQueries({ queryKey: CLIENT_SEAT_USERS_QUERY_KEY })
    },
  })
}
